<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <el-row>
          <el-col>
            <el-form :inline="true" :model="searchCondition">
              <el-form-item label="发放状态">
                <el-select clearable v-model="searchCondition.send_status">
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="时间">
                <DatePicker @dataSearch="dataSearch" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="searchButton">查询</el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col>
            <ScreeCompany @ScreeCompany="ScreeCompany" />
          </el-col>
        </el-row>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane
            v-for="(item, index) in this.tabsList"
            :label="item.label"
            :key="index"
            :name="item.name"
          >
          </el-tab-pane>
          <ApeTable
            ref="apeTable"
            :data="dataList"
            :columns="columns"
            :loading="loadingStaus"
            :pagingData="pagingData"
            @switchPaging="switchPaging"
            highlight-current-row
          >
            <el-table-column
              slot="first-column"
              align="center"
              label="公司名称"
            >
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row.id"
                  placement="top"
                >
                  <div>{{ scope.row.company_name }}</div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              slot="second-column"
              width="100"
              align="center"
              label="结算单"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="text"
                  @click="downSettlement(scope.row)"
                >
                  <i class="iconfont iconxiazai iconbtn iconBtns"></i>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              slot="second-column"
              prop="money"
              align="center"
              sortable
              label="总金额"
            >
              <template slot-scope="scope">
                <div class="tag-group">
                  <el-tag type="warning" class="tag-item">
                    <div>总金额：{{ scope.row.total_amount }}</div>
                  </el-tag>
                  <el-tag type="warning" class="tag-item">
                    <div>人员数：{{ scope.row.total_num }}</div>
                  </el-tag>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="money" align="center" label="批次状态">
              <template slot-scope="scope">
                <div>
                  <div>{{ scope.row.status_text }}</div>
                  <div v-if="scope.row.risk_status == 0" style="color:red;">
                    风控处理中
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column width="180" label="操作" align="center">
              <template slot-scope="scope">
                <span>
                  <el-button
                    size="mini"
                    :disabled="scope.row.risk_status == 0"
                    type="danger"
                    v-if="
                      scope.row.status === 1 &&
                        userPermissions.indexOf('task_audit') != -1 && getIsCanAudit(scope.row.created_at)
                    "
                    @click="viewButton(scope.row.id, 'audit',scope.row.channel_name)"
                    >审批任务</el-button
                  >
                  <el-button
                    size="mini"
                    type="primary"
                    @click="viewButton(scope.row.id, 'detail',scope.row.channel_name)"
                    >发放明细</el-button
                  >
                </span>
              </template>
            </el-table-column>
          </ApeTable>
        </el-tabs>
      </div>
    </PageHeaderLayout>
    <!-- 审批组建 -->
    <BatchDetail
      @dialogChanged="dialogChanged($event)"
      @onSuccess="handleSuccess($event)"
      :dialogBatchVisible="approvaDialogVisible"
      :batchId="batchId"
      :channelName="dialog_channelName"
      :dialogType="'audit'"
    />
    <!-- 发放明细 -->
    <BatchDetail
      @dialogChanged="dialogChanged($event)"
      @onSuccess="handleDetailSuccess($event)"
      :dialogBatchVisible="detailDialogVisible"
      :channelName="dialog_channelName"
      :batchId="batchId"
      :dialogType="'detail'"
    />
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import DatePicker from "@/components/DatePicker.vue";
import BatchDetail from "./GreenCityBatchDetail.vue";
import ScreeCompany from "@/components/ScreeCompany.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    DatePicker,
    BatchDetail,
    ScreeCompany,
  },
  data() {
    return {
      dialog_channelName:'',
      statusOptions: [
        {
          value: "00",
          label: "待处理",
        },
        {
          value: "02",
          label: "发放失败",
        },
        {
          value: "11",
          label: "已发放",
        },
      ],
      activeName: "1",
      tabsList: [
        {
          label: "待处理",
          name: "1",
        },
        {
          label: "已处理",
          name: "2,3,4,5",
        },
      ],
      batchId: "",
      detailDialogVisible: false,
      approvaDialogVisible: false,
      // 搜索条件
      searchCondition: {},
      loadingStaus: true,
      columns: [
        {
          title: "当前余额",
          value: "balance",
          header_align: "center",
          align: "center",
        },
        {
          title: "税源地名称",
          value: "channel_name",
          header_align: "center",
          align: "center",
        },
        {
          title: "成功金额",
          header_align: "center",
          align: "center",
          value: "succeed_money",
        },
        {
          title: "失败金额",
          header_align: "center",
          align: "center",
          value: "failed_money",
        },
        {
          title: "发放状态",
          header_align: "center",
          align: "center",
          value: "send_msg",
        },
        {
          title: "批次时间",
          header_align: "center",
          align: "center",
          value: "created_at",
          // width: 170
        },
        {
          title: "提交时间",
          header_align: "center",
          align: "center",
          value: "check_time",
          // width: 170
        },
      ],
      // 表格列表数据
      dataList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      // 分页的offset,序号列使用
      offset: 0,
    };
  },
  computed: {
    ...mapGetters(["userPermissions"]),
  },
  watch: {
    "$route.matched": function(n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    },
  },
  methods: {
    // 判断是否是当月的数据
    getIsCanAudit(time) {
      if(!time) return false;
      let m1 = new Date(time).getMonth()+1;
      let m2 = new Date().getMonth()+1;
      return m1 === m2;
    },
    //导出表格数据
    async downSettlement(e) {
      this.downloadLoading = true;
      let { id } = e;
      let param = {
        batch_id: id,
        send_status: "02",
      };
      let dataList = await this.$api.getGreenCityDownloadAdminTask(param);
      console.log(dataList, 1111);
      import("@/excel/Export2Excel").then((excel) => {
        const tHeader = [
          "code",
          "name",
          "cardType",
          "idCard",
          "phone",
          "bankCard",
          "bankName",
          "accountName",
          "money",
          "remark",
          "type",
          "green_trade_no",
        ];
        let data_head = [
          [
            "【编码（选填,20位以内）】",
            "【姓名】",
            "【证件类型(1:身份证2:港澳台通行证3：护照4：军官证)】",
            "【身份证号码】",
            "【手机号码/微信签约手机号/微信openid】",
            "【账号(银行卡号或支付宝邮箱账号)】",
            "【银行名称（选填）】",
            "【银行卡开户行名称（选填）】",
            "【税后金额(单位元)】",
            "【备注】",
            "【下发类型(OTHERBANK:银行卡;ALIPAY:支付宝);WECHAT:微信】",
            "【绿城关联ID】",
          ],
        ];
        const data = data_head.concat(this.formatJson(dataList));
        console.log(data);
        const time = new Date().getTime() + Math.random() * 1000;
        let filename = `失败订单下载(${id})${time}`;
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.bookType, //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(jsonData) {
      return jsonData.map((v) => {
        let {
          code,
          bank_account_name,
          id_type,
          id_number,
          mobile,
          bank_account_no,
          bank_name,
          bank_branch,
          money,
          remark,
          bank_code,
          green_trade_no,
        } = v;
        return [
          code,
          bank_account_name,
          id_type,
          id_number,
          mobile,
          bank_account_no,
          bank_name,
          bank_branch,
          money,
          remark,
          bank_code,
          green_trade_no,
        ];
      });
    },
    //切换tab
    async handleClick(tab) {
      this.activeName = tab.name;
      this.init("search");
    },
    ScreeCompany(v, name) {
      if (name == "company") {
        if (v) {
          this.searchCondition.company_id = v;
        } else {
          delete this.searchCondition.company_id;
        }
        this.init("search");
      }

      if (name == "settlement") {
        if (v) {
          this.searchCondition.channel_account = v;
        } else {
          delete this.searchCondition.channel_account;
        }
        this.init("search");
      }
    },
    // 搜索
    searchButton() {
      this.init("search");
    },
    // 切换页码操作
    async switchPaging() {
      this.init();
    },
    // 响应详情按钮
    async viewButton(id, type = "",channel_name) {
      this.batchId = id;
      this.dialog_channelName = channel_name
      if (type == "detail") {
        //明细弹窗
        this.detailDialogVisible = true;
      } else {
        //审批弹窗
        this.approvaDialogVisible = true;
      }
    },
    // 审核成功回调
    handleSuccess() {
      this.approvaDialogVisible = false;
      this.init();
      console.log("handleSuccess1");
    },
    // 明细详情回调
    handleDetailSuccess() {
      console.log("handleSuccess2");
    },
    // 统一关闭弹窗
    dialogChanged(type) {
      if (type == "audit") {
        this.approvaDialogVisible = false;
      }

      if (type == "detail") {
        this.detailDialogVisible = false;
      }
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.start_time = value[0];
      this.searchCondition.end_time = value[1];
    },
    // 初始化列表
    async init(type) {
      if (type) {
        this.mxResetPage();
      }
      this.loadingStaus = true;
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      if (type == "search") {
        pagingInfo.current_page = 1;
      }
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, pagingInfo);
      let { data, pages } = await this.$api.getGreenCityAdminTaskList(
        searchCondition
      );
      this.$nextTick(() => {
        this.dataList = data;
      });
      this.pagingData.total = pages.total;
      this.offset = pages.offset;
      this.loadingStaus = false;
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.activeName) {
        condition.status = this.activeName;
      }
      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name;
      }
      if (this.searchCondition.start_time) {
        condition.start_time = this.searchCondition.start_time;
      }
      if (this.searchCondition.end_time) {
        condition.end_time = this.searchCondition.end_time;
      }
      if (this.searchCondition.send_status) {
        condition.send_status = this.searchCondition.send_status;
      }
      if (
        this.searchCondition.company_id ||
        this.searchCondition.channel_account
      ) {
        condition.company_id = this.searchCondition.company_id;
        condition.channel_account = this.searchCondition.channel_account;
      }
      return condition;
    },
    keyupSubmit() {
      document.onkeydown = (e) => {
        console.log(e);
        let _key = window.event.keyCode;
        if (_key === 13) {
          this.searchButton();
        }
      };
    },
  },

  created() {
    this.keyupSubmit();
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.el-button
  margin-right 4px
  margin-bottom 4px
.el-button + .el-button
  margin-left: 0
.table-header
  margin-bottom 12px
.el-popover .el-checkbox-group .el-checkbox
  margin-left 0px
  margin-right 12px
.submitBtn
  float: right
  margin-top: 20px
.link-url
  color: #fff
  text-decoration:none
.iconBtns
  font-size: 20px
  color: rgba(0, 183, 158, 1)
.tag-group
  display: flex
  flex-direction: column
.tag-item
  margin: 5px 0
// .table-search
//   height: 36px
</style>
